import {Component, OnInit} from '@angular/core';
import {Column} from '../../share/models/column';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {SelectItem} from 'primeng/api';
import {BaseClientComponent} from '../base-client.component';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import * as _ from 'lodash';
import {SymbolDataDownloadLogFilterCriteria} from '../../models/filter/symbol-data-download-log-filter-criteria';
import {SymbolDataDownloadLogService} from '../../services/symbol-data-download-log.service';
import {TableService} from '../../services/table.service';
import {SymbolDataDownloadLog} from '../../models/symbol-data-download-log';

@Component({
  selector: 'app-symbol-data-download-log',
  templateUrl: './symbol-data-download-log.component.html',
  styleUrls: ['./symbol-data-download-log.component.scss']
})
export class SymbolDataDownloadLogComponent extends BaseClientComponent implements OnInit {
  firstPage = 0;
  cols: Column[];
  symbolDataDownloadLogFilterCriteria: SymbolDataDownloadLogFilterCriteria;
  typeItems: SelectItem[];
  symbolDataDownloadLogList: SymbolDataDownloadLog[];
  page = 1;
  permission: boolean;
  userChoicesFiltersDefaultSymbolDataDownloadLog = {
    'type': 'All', 'dateFrom': null, 'dateTo': null, 'user': null, 'company': null, 'downloadedData': null
  };
  userItems: SelectItem[] = [];
  downloadedDataItems: SelectItem[] = [];
  companyItems: SelectItem[] = [];
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultSymbolDataDownloadLog);
  totalItems = 0;
  totalPages = 0;

  constructor(
    public authenticationService: AuthenticationService,
    private symbolDataDownloadLogService: SymbolDataDownloadLogService,
    protected utilsService: UtilsService,
    public tableService: TableService,
    protected http: HttpClient) {
    super();
    this.typeItems = [{label: 'All', value: 'All'}, {label: 'UI', value: 'UI'}, {label: 'CLI', value: 'CLI'}];
  }

  ngOnInit() {
    this.permission = this.authenticationService.getUserCurrent().permissions.canAccessRecipients;
    this.userChoicesActiveFilters = this.utilsService.loadUserPref('symbolDataDownloadLogFilter', this.userChoicesActiveFilters);
    this.symbolDataDownloadLogFilterCriteria = new SymbolDataDownloadLogFilterCriteria(this.userChoicesActiveFilters);
    const response = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.initializeColumns();
      this.getDownloadedSymbolDataLog();
      this.setCompaniesAndUsersList();
    });
    this.subscriptions.push(response);
  }

  setCompaniesAndUsersList() {
    const uniqueItems = (list: SelectItem[]) => list
      .filter((item, index, self) => self.findIndex(i => i.value === item.value) === index)
      .sort((a, b) => a && b && a.label.localeCompare(b.label));
    this.symbolDataDownloadLogService.getSymbolDataDownloadLogListFilters().subscribe(res => {
      this.companyItems = uniqueItems(
        res.companies.map(company => ({
          label: company,
          value: company,
        } as SelectItem))
      );
      this.userItems = uniqueItems(
        res.users.map(user => ({
          label: user,
          value: user,
        } as SelectItem))
      );
      this.downloadedDataItems = uniqueItems(
        res.downloadedData.map(data => ({
          label: data,
          value: data,
        } as SelectItem))
      );
    });

    this.userItems.unshift({label: 'All', value: 'All'});
    this.downloadedDataItems.unshift({label: 'All', value: 'All'});
    this.companyItems.unshift({label: 'All', value: 'All'});
  }

  resetTable(): void {
    this.utilsService.saveUserData('symbolDataDownloadLogFilter', this.userChoicesFiltersDefaultSymbolDataDownloadLog);
    this.symbolDataDownloadLogFilterCriteria = new SymbolDataDownloadLogFilterCriteria(this.userChoicesFiltersDefaultSymbolDataDownloadLog);
    this.firstPage = 0;
    this.page = 1;
    this.getDownloadedSymbolDataLog();
  }

  filter() {
    this.utilsService.saveUserData('symbolDataDownloadLogFilter', {
      'type': this.symbolDataDownloadLogFilterCriteria.type,
      'company': this.symbolDataDownloadLogFilterCriteria.company,
      'user': this.symbolDataDownloadLogFilterCriteria.user,
      'downloadedData': this.symbolDataDownloadLogFilterCriteria.downloadedData,
      'dateFrom': this.symbolDataDownloadLogFilterCriteria.dateFrom,
      'dateTo': this.symbolDataDownloadLogFilterCriteria.dateTo,
    });
    this.page = 1;
    this.getDownloadedSymbolDataLog();
  }

  redirectionToNotFound() {
    location.assign('/#/404');
  }

  getUserName(document: { userName: string; }) {
    if (!document.userName) {
      document.userName = 'User was removed';
    }
    return document.userName;
  }

  getUserCompanyName(document: { userCompanyName: any; }) {
    return (!document.userCompanyName) ? '' : document.userCompanyName;
  }

  getUserEmail(document: { userEmail: any; }) {
    return (!document.userEmail) ? '' : document.userEmail;
  }

  private initializeColumns() {
    this.cols = [];
    this.cols = [
      {field: 'createdAt', header: 'Date', type: 'Date', sortable: true, width: '15%'},
      {field: 'downloadedData', header: 'Downloaded data', type: 'string', sortable: true, width: '20%'},
      {field: 'type', header: 'Type', type: 'string', sortable: true, width: '15%'},
      {field: 'userName', header: 'User name', type: 'string', sortable: true, width: '20%'},
      {field: 'companyName', header: 'Company name', type: 'string', sortable: true, width: '15%'},
      {field: 'userEmail', header: 'Email', type: 'string', sortable: true, width: '20%'},
      {field: 'method', header: 'Method', type: 'string', sortable: false, width: '20%'}
    ];
  }

  private getDownloadedSymbolDataLog() {
    this.utilsService.lockUi();
    this.symbolDataDownloadLogService.getSymbolDataDownloadLogList(
      this.page,
      this.symbolDataDownloadLogFilterCriteria.user,
      this.symbolDataDownloadLogFilterCriteria.company,
      this.symbolDataDownloadLogFilterCriteria.type,
      this.symbolDataDownloadLogFilterCriteria.downloadedData,
      this.symbolDataDownloadLogFilterCriteria.dateFrom,
      this.symbolDataDownloadLogFilterCriteria.dateTo,
      null, null
    ).subscribe({
      next: res => {
        this.totalItems = res.totalItems;
        this.totalPages = res.totalPages;
        this.page = res.currentPage;
        this.symbolDataDownloadLogList = res.data.sort((a, b) => {
          return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
        });
        this.utilsService.unlockUi();
      }, error: () => {
        this.redirectionToNotFound();
      }
    });
  }

  loadLazy(event) {
    if (this.page === (event.first / 20 + 1)) { // Prevent loading the data twice on page init
      return;
    }
    this.page = (event.first / 20) + 1;
    const sortField = event.sortField || 'createdAt';
    const sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    this.symbolDataDownloadLogService.getSymbolDataDownloadLogList(
      this.page,
      this.symbolDataDownloadLogFilterCriteria.user,
      this.symbolDataDownloadLogFilterCriteria.company,
      this.symbolDataDownloadLogFilterCriteria.type,
      this.symbolDataDownloadLogFilterCriteria.downloadedData,
      this.symbolDataDownloadLogFilterCriteria.dateFrom,
      this.symbolDataDownloadLogFilterCriteria.dateTo,
      sortField,
      sortOrder
    ).subscribe(res => {
      this.totalItems = res.totalItems;
      this.totalPages = res.totalPages;
      this.page = res.currentPage;
      this.symbolDataDownloadLogList = res.data;
      this.utilsService.unlockUi();
    });
  }
}
